// extracted by mini-css-extract-plugin
export var darkMode = "_1h-0";